
function dhcNarrowDownCustomerPrompt(){
  return 'Help me narrow these choices down more.';
}


document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-dhc-slider]').forEach(function(slider){
    var slides=[...slider.querySelectorAll('.dhc-hero-slide')], dots=[...slider.querySelectorAll('.dhc-slider-dot')];
    if(!slides.length)return; var active=0;
    function show(i){slides.forEach((s,x)=>s.classList.toggle('is-active',x===i));dots.forEach((d,x)=>d.classList.toggle('is-active',x===i));active=i}
    dots.forEach((d,i)=>d.addEventListener('click',()=>show(i))); show(0);
  });
  var topBtn=document.querySelector('.dhc-backtotop');
  if(topBtn){window.addEventListener('scroll',()=>topBtn.style.display=window.scrollY>700?'block':'none');topBtn.addEventListener('click',()=>window.scrollTo({top:0,behavior:'smooth'}));}
  document.querySelectorAll('[data-cart-progress]').forEach(function(el){
    var total=parseFloat(el.dataset.total||0), threshold=parseFloat(el.dataset.threshold||59);
    var pct=Math.min(100,(total/threshold)*100); var bar=el.querySelector('.dhc-cart-progress__bar'); if(bar)bar.style.width=pct+'%';
  });
});

/* v1052.20: legacy cart drawer controller removed; section owns cart drawer. */
document.addEventListener('DOMContentLoaded',function(){
  function read(key){try{return JSON.parse(localStorage.getItem(key)||"[]")}catch{return[]}}
  function write(key,v){try{localStorage.setItem(key,JSON.stringify(v))}catch{}}
  const productNode=document.querySelector('[data-dhc-product-json]');
  if(productNode){
    try{
      const p=JSON.parse(productNode.textContent);
      if(p&&p.id){
        let recent=read('dhc_recent').filter(x=>String(x.id)!==String(p.id));
        recent.unshift(p); recent=recent.slice(0,20); write('dhc_recent',recent);
        const b=document.querySelector('[data-dhc-wishlist]');
        if(b){
          function sync(){const list=read('dhc_wishlist');const on=list.some(x=>String(x.id)===String(p.id));b.textContent=on?'Remove from Wishlist':'Add to Wishlist';b.setAttribute('aria-pressed',on?'true':'false')}
          b.addEventListener('click',function(){let list=read('dhc_wishlist');const i=list.findIndex(x=>String(x.id)===String(p.id));if(i>=0)list.splice(i,1);else list.unshift(p);write('dhc_wishlist',list.slice(0,100));sync()});sync();
        }
      }
    }catch(e){}
  }
  const grid=document.querySelector('[data-dhc-wishlist-grid]');
  if(grid){
    const list=read('dhc_wishlist');
    if(list.length)grid.innerHTML=list.map(p=>`<a class="dhc-basic-product" href="${p.url}">${p.image?`<img src="${p.image}" alt="${String(p.title).replace(/"/g,'&quot;')}">`:''}<h3>${p.title}</h3><strong>${p.price||''}</strong></a>`).join('');
  }
  document.querySelectorAll('[data-recently-viewed]').forEach(function(el){
    const list=read('dhc_recent');
    const box=el.querySelector('.dhc-recents'); if(box&&list.length)box.innerHTML=list.map(p=>`<a class="dhc-basic-product" href="${p.url}">${p.image?`<img src="${p.image}" alt="${String(p.title).replace(/"/g,'&quot;')}">`:''}<h3>${p.title}</h3><strong>${p.price||''}</strong></a>`).join('');
  });
  const searchInputs=document.querySelectorAll('.dhc-search input[type="search"]');
  searchInputs.forEach(function(input){
    let timer;
    input.addEventListener('input',function(){
      clearTimeout(timer); const q=input.value.trim(); const wrap=input.closest('.dhc-search-wrap'); const shell=wrap?.querySelector('[data-predictive-shell]');
      if(!shell||q.length<2){if(shell)shell.innerHTML='';return}
      timer=setTimeout(async()=>{try{
        const root=(window.Shopify?.routes?.root||'/');
        const url=`${root}search/suggest?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,page,article&resources[limit]=5`;
        const r=await fetch(url); const t=await r.text(); const d=new DOMParser().parseFromString(t,'text/html'); shell.innerHTML=d.querySelector('#shopify-section-predictive-search')?.innerHTML||'';
      }catch(e){}},180);
    });
  });
});

/* DHC v16 Bundle Builder */
document.addEventListener('DOMContentLoaded',()=>{
 document.querySelectorAll('[data-bundle-builder]').forEach(root=>{
  const checks=[...root.querySelectorAll('.dhc-bundle-check')], count=root.querySelector('[data-bundle-count]'),
  total=root.querySelector('[data-bundle-total]'), btn=root.querySelector('[data-bundle-add]'), msg=root.querySelector('[data-bundle-message]');
  const money=c=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(c/100);
  function sync(){const on=checks.filter(x=>x.checked);count.textContent=on.length;total.textContent=money(on.reduce((s,x)=>s+Number(x.dataset.price||0),0));btn.disabled=!on.length}
  checks.forEach(x=>x.addEventListener('change',sync));sync();
  btn.addEventListener('click',async()=>{
   const items=checks.filter(x=>x.checked).map(x=>({id:Number(x.dataset.variantId),quantity:1}));
   if(!items.length)return; btn.disabled=true; msg.textContent='Adding your bundle…';
   try{const r=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
   if(!r.ok)throw new Error('Cart add failed'); msg.textContent='Bundle added to cart.'; document.dispatchEvent(new CustomEvent('cart:refresh')); }
   catch(e){msg.textContent='We could not add the bundle. Please try again.'} finally{btn.disabled=false}
  });
 });
});

/* v26 AI Customer Service */
document.addEventListener('DOMContentLoaded',()=>{
 document.querySelectorAll('[data-dhc-support]').forEach(root=>{
  const panel=root.querySelector('[data-support-panel]'),open=root.querySelector('[data-support-open]'),close=root.querySelector('[data-support-close]'),
  outerClose=root.querySelector('[data-dhc-jack-close]'),
  form=root.querySelector('[data-support-form]'),msgs=root.querySelector('[data-support-messages]');

  const DHC_CHAT_ID_KEY='dhc_support_conversation';
  const DHC_CHAT_TRANSCRIPT_KEY='dhc_jack_transcript_v844';
  const DHC_CHAT_OPEN_KEY='dhc_jack_open_v844';

  let conversationId=sessionStorage.getItem(DHC_CHAT_ID_KEY)||null;

  function dhcLoadTranscript(){
    try{
      const rows=JSON.parse(sessionStorage.getItem(DHC_CHAT_TRANSCRIPT_KEY)||'[]');
      return Array.isArray(rows)?rows:[];
    }catch(e){return[]}
  }
  function dhcSaveTranscript(rows){
    try{sessionStorage.setItem(DHC_CHAT_TRANSCRIPT_KEY,JSON.stringify((rows||[]).slice(-80)))}catch(e){}
  }
  function dhcClearConversation(){
    conversationId=null;
    try{
      sessionStorage.removeItem(DHC_CHAT_ID_KEY);
      sessionStorage.removeItem(DHC_CHAT_TRANSCRIPT_KEY);
      sessionStorage.removeItem(DHC_CHAT_OPEN_KEY);
    }catch(e){}
    try{if(window.DHCJackOffline&&typeof window.DHCJackOffline.reset==='function')window.DHCJackOffline.reset()}catch(e){}
  }
  const jackCatalogState={
    target:null,audience:null,size:null,budgetMax:null,style:null,color:null,occasion:null,
    availabilityOnly:false,deliverySensitive:false,completeLook:false,lastProducts:[]
  };

  const DHC_JACK_SPELLING={
    wensday:'wednesday',wendsday:'wednesday',wensdey:'wednesday',
    vampier:'vampire',vampyre:'vampire',skelton:'skeleton',skeleten:'skeleton',
    animatronicc:'animatronic',animatronik:'animatronic',
    unicon:'unicorn',unicron:'unicorn',unicornn:'unicorn',
    costum:'costume',costumee:'costume',costums:'costumes',
    witche:'witch',zombi:'zombie',princes:'princess'
  };

  const DHC_JACK_SYNONYMS={
    cowboy:['western','cowboy'],western:['cowboy','western'],
    cop:['police','cop'],police:['cop','police'],
    fairy:['pixie','fairy'],pixie:['fairy','pixie'],
    devil:['demon','devil'],demon:['devil','demon'],
    'grim reaper':['reaper','death','grim reaper'],reaper:['grim reaper','death','reaper'],
    doctor:['medical','doctor'],nurse:['medical','nurse'],
    cat:['feline','cat'],feline:['cat','feline'],
    zombie:['undead','zombie'],undead:['zombie','undead'],
    vampire:['dracula','vampire'],dracula:['vampire','dracula']
  };

  function dhcNormalizeRetailText(v){
    let s=String(v||'').toLowerCase().replace(/[’']/g,"'").trim();
    Object.keys(DHC_JACK_SPELLING).forEach(k=>{
      s=s.replace(new RegExp('\\b'+k+'\\b','g'),DHC_JACK_SPELLING[k]);
    });
    return s.replace(/\s+/g,' ').trim();
  }

  function dhcAudienceFromMessage(message){
    const q=dhcNormalizeRetailText(message);
    // Explicit pet ownership/fit language is decisive. Bare animal names are themes.
    if(/\b(pet|pets|puppy|kitten)\b/.test(q)||/\b(?:for\s+(?:my|a|the)\s+|my\s+)(?:dog|cat)\b/.test(q)||/\b(?:dog|cat)\s+(?:size|clothes|clothing|apparel)\b/.test(q))return 'pets';
    // Strong audience phrases beat theme words such as "bunny girl", "old man", or "cat woman".
    if(/\b(toddler|little kid|young child|teen|teenager|teenage|youth|kid|kids|child|children|son|daughter)\b/.test(q)||/\bfor\s+(?:a|my|the)?\s*(?:boy|boys|girl|girls)\b/.test(q)||/\b(?:boys|girls)['’]?\s/.test(q)||/\b\d{1,2}\s*[- ]?year[- ]?old\b/.test(q))return 'kids';
    if(/\b(adult|adults|grownup|grown-up)\b/.test(q)&&/\b(old man|cat woman|catwoman|gingerbread man|ant man|spider man|iron man|bat man|batman|superman|wonder woman|super girl|bat girl)\b/.test(q))return 'adults';
    if(/\b(plus size|plus-size|extended size)\b/.test(q))return 'plus size';
    if(/\b(couple|couples|matching couple|matching pair)\b/.test(q))return 'couples';
    if(/\b(woman|women|womens|women's|female|lady|ladies|wife|mom|mother)\b/.test(q))return 'womens';
    if(/\b(man|men|mens|men's|male|guy|guys|husband|dad|father)\b/.test(q))return 'mens';
    if(/\b(adult|adults|grownup|grown-up)\b/.test(q))return 'adults';
    // Weak standalone boy/girl wording is used only when no stronger audience was supplied.
    if(/\b(boy|boys|girl|girls)\b/.test(q))return 'kids';
    return null;
  }
  function dhcProductTypeFromMessage(message){
    const q=dhcNormalizeRetailText(message);
    // Explicit "only/just" accessory intent is decisive.
    if(/\b(mask only|just a mask|only a mask)\b/.test(q)&&!/\b(not|dont|don't|do not)\s+(?:want\s+)?(?:just|only)?\s*(?:a\s+)?mask\b/.test(q))return 'mask';
    if(/\b(wig only|just a wig|only a wig|hairpiece only)\b/.test(q))return 'wig';
    if(/\b(makeup only|just makeup|face paint only|prosthetic only|fake blood only)\b/.test(q))return 'makeup';
    if(/\b(prop only|just a prop|only a prop|sword only|wand only|weapon only)\b/.test(q))return 'prop';
    if(/\b(hat only|just a hat|only a hat|headpiece only|crown only|tiara only)\b/.test(q))return 'headwear';
    // "X for a costume" means X is the requested item, not the costume itself.
    if(/\b(mask|wig|makeup|face paint|prosthetic|fake blood|prop|sword|wand|hat|crown|tiara|gloves?|cape|wings|tail|ears|horns?)\b.{0,24}\bfor (?:a |my |the )?costume\b/.test(q)){
      if(/\bmask\b/.test(q))return 'mask';if(/\bwig|hairpiece\b/.test(q))return 'wig';if(/\bmakeup|face paint|prosthetic|fake blood\b/.test(q))return 'makeup';if(/\bprop|sword|wand\b/.test(q))return 'prop';if(/\bhat|crown|tiara\b/.test(q))return 'headwear';return 'accessory';
    }
    // Main costume nouns outrank incidental included accessories or theme words.
    if(/\b(inflatable\s+costume|costume|outfit|jumpsuit|bodysuit|robe|uniform|cosplay|onesie|romper|costume dress|costume set)\b/.test(q))return 'costume';
    // Decorations require an explicit decor object/use. Theme nouns such as skeleton/ghost/spider alone never imply decor.
    if(/\b(animatronic|animatronics)\b/.test(q))return 'animatronic';
    if(/\b(decoration|decorations|decor|yard decor|outdoor decor|indoor decor|tombstone|grave marker|wreath|garland|fog machine|projector|yard inflatable|inflatable decoration|porch decoration|hanging decoration|door decoration|window decoration|lawn decoration)\b/.test(q))return 'decoration';
    if(/\b(party supplies|party supply|plates?|cups?|napkins?|tablecloth|balloons?|party banner|treat bags?)\b/.test(q))return 'party-supplies';
    if(/\b(prank|gag gift|novelty|joke item|fake poop|whoopee cushion)\b/.test(q))return 'prank';
    if(/\b(mask|masks|helmet)\b/.test(q))return 'mask';
    if(/\b(wig|wigs|hairpiece)\b/.test(q))return 'wig';
    if(/\b(makeup|face paint|fake blood|prosthetic|prosthetics|scar wax|latex wound)\b/.test(q))return 'makeup';
    if(/\b(prop|props|sword|axe|scythe|wand|staff|shield|hook|pitchfork|machete)\b/.test(q))return 'prop';
    if(/\b(hat|cap|fedora|crown|tiara|headband|headpiece)\b/.test(q))return 'headwear';
    if(/\b(accessory|accessories|gloves?|cape|cloak|wings|tail|ears|horns|boot covers?|jewelry|fangs|teeth)\b/.test(q))return 'accessory';
    return null;
  }
  window.DHCJackProductTypeFromMessage=dhcProductTypeFromMessage;
  function dhcExtractRetailFilters(message){
    const q=dhcNormalizeRetailText(message);
    const sizeMap={small:'S',medium:'M',large:'L','extra large':'XL','extra-large':'XL'};
    let size=(q.match(/\b(?:size\s*)?(xs|s|m|l|xl|xxl|xxxl|2xl|3xl|4xl|5xl)\b/i)||[])[1]||null;
    if(!size){
      const sm=q.match(/\b(?:size\s*)?(extra[- ]large|small|medium|large)\b/i);
      if(sm)size=sizeMap[String(sm[1]).toLowerCase()]||null;
    }
    if(!size)size=(q.match(/\bsize\s*(\d{1,2})\b/i)||[])[1]||null;

    const hardBudget=(q.match(/\b(?:under|below|less than|max(?:imum)?|up to|no more than|do not go over|don't go over|dont go over)\s*\$?\s*(\d{1,4})\b/i)||[])[1] ||
      (q.match(/\$\s*(\d{1,4})\s*(?:or less|max(?:imum)?)\b/i)||[])[1] || null;
    const standaloneDollar=(q.match(/\$\s*(\d{1,4})\b/i)||[])[1]||null;
    const shoppingContext=/\b(costume|outfit|mask|wig|prop|decor|decoration|animatronic|show me|find me|need|looking for|wants?|shopping for)\b/.test(q);
    const budget=hardBudget || (shoppingContext?standaloneDollar:null);

    const styles=['cute','funny','scary','creepy','realistic','easy','last minute','last-minute','glam','princess','classic','family friendly','family-friendly','sexy','flirty'];
    const colors=['black','white','red','pink','purple','green','blue','orange','yellow','gold','silver','brown','gray','grey'];
    const occasions=[['school','school'],['office','office'],['work party','office'],['halloween party','party'],['costume party','party'],['trick or treating','trick-or-treating'],['trick-or-treating','trick-or-treating'],['haunted house','haunted house'],['costume contest','costume contest']];
    let style=styles.find(x=>q.includes(x))||null;
    let color=colors.find(x=>new RegExp('\\b'+x+'\\b').test(q))||null;
    let occasion=null;for(const [needle,label] of occasions){if(q.includes(needle)){occasion=label;break;}}

    const fullCostume=/\b(full|complete|whole|head to toe)\b.{0,18}\b(costume|outfit|look)\b|\b(costume|outfit)\b.{0,18}\b(full|complete|whole)\b|\bnot (?:just|only) (?:a )?(mask|wig|prop|accessory)\b|\bno mask-only\b/.test(q);
    const accessoryOnly=/\b(mask only|just a mask|only a mask|wig only|just a wig|only a wig|prop only|just a prop|only a prop)\b/.test(q);
    const availabilityOnly=/\b(in stock|available now|actually available|available today|actually have available|have available|what you (?:actually )?have available|currently available|you have available)\b/.test(q);

    return {
      size:size?String(size).toUpperCase():null,
      budgetMax:budget?Number(budget):null,
      budgetHard:!!hardBudget,
      style,color,occasion,
      availabilityOnly,
      deliverySensitive:/\b(arrive fast|get here fast|fast delivery|quick delivery|arrive by|need it by|before friday|before saturday|before sunday|before halloween|by halloween)\b/.test(q),
      fullCostume:fullCostume&&!accessoryOnly,
      accessoryOnly,
      completeLook:/\b(complete look|everything for|full look|build me a|matching accessories|complete outfit)\b/.test(q),
      similar:/\b(something like this|similar to this|similar but|same thing|another one|another .*costume|anything similar|like this one)\b/.test(q),
      cheaper:/\b(cheaper|less expensive|lower price|budget version)\b/.test(q)
    };
  }

  function dhcSpecificThemeFromMessage(message){
    const q=dhcNormalizeRetailText(message);
    const stop=new Set(['a','an','the','costume','costumes','outfit','outfits','mask','masks','wig','wigs','prop','props','kid','kids','child','children','boy','boys','girl','girls','son','daughter','man','men','woman','women','adult','something','anything','full','complete','whole']);
    const patterns=[
      /\b(?:wants?|want|wanted)\s+to\s+be\s+(?:a|an|the)?\s*([a-z][a-z'-]{2,30})\b/,
      /\b(?:dress(?:ed)?\s+as|be|become)\s+(?:a|an|the)?\s*([a-z][a-z'-]{2,30})\b/,
      /\b(?:like|similar to)\s+(?:a|an|the)?\s*([a-z][a-z'-]{2,30})\b/,
      /\b(?:full|complete|whole)?\s*([a-z][a-z'-]{2,30})\s+(?:costume|outfit|mask|wig|prop)\b/
    ];
    for(const rx of patterns){const m=q.match(rx);if(m){const x=String(m[1]||'').trim();if(x&&!stop.has(x))return x;}}
    const known=['shark','dinosaur','dragon','lion','tiger','bear','wolf','fox','bee','butterfly','spider','bat','ghost','witch','vampire','zombie','clown','unicorn','pirate','cowboy','fairy','devil','demon','skeleton','reaper','princess','police','doctor','nurse','cat','dog','monkey','gorilla','rabbit','bunny','chicken','duck','frog','fish','octopus','lobster','crab','mermaid','alien','robot','ninja'];
    return known.find(x=>new RegExp('\\b'+x+'\\b').test(q))||null;
  }

  function dhcThemeRecoveryTargets(theme){
    const x=dhcNormalizeRetailText(theme);
    const map={
      shark:['sea creature costume','ocean animal costume','fish costume','animal costume'],
      fish:['sea creature costume','ocean animal costume','animal costume'],
      octopus:['sea creature costume','ocean animal costume','animal costume'],
      lobster:['sea creature costume','ocean animal costume','animal costume'],
      crab:['sea creature costume','ocean animal costume','animal costume'],
      dinosaur:['prehistoric costume','reptile costume','animal costume'],
      dragon:['mythical creature costume','reptile costume','fantasy costume'],
      lion:['wild animal costume','cat costume','animal costume'],
      tiger:['wild animal costume','cat costume','animal costume'],
      bear:['wild animal costume','animal costume'],
      wolf:['wild animal costume','animal costume'],
      bee:['insect costume','bug costume','animal costume'],
      butterfly:['insect costume','bug costume','animal costume'],
      monkey:['jungle animal costume','animal costume'],
      gorilla:['jungle animal costume','animal costume']
    };
    return map[x]||[];
  }

  function dhcProductMatchesRequiredTheme(product,requiredTheme){
    if(!requiredTheme)return true;
    const text=dhcProductText(product);
    const tokens=dhcTokenize(requiredTheme).filter(x=>!['costume','outfit','mask','wig','prop','decor','decoration'].includes(x));
    if(!tokens.length)return true;
    return tokens.some(tok=>new RegExp('(^|[^a-z0-9])'+tok.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+'([^a-z0-9]|$)').test(text));
  }

  function dhcProductLooksLikeFullCostume(product){
    const text=dhcProductText(product);
    if(/\b(mask only|wig only|prop only|accessory|accessories|headwear|belt only|cape only)\b/.test(text)&&!(/\bcostume\b/.test(text)&&/\b(suit|dress|jumpsuit|robe|outfit|costume set)\b/.test(text)))return false;
    return /\b(costume|outfit|suit|dress|jumpsuit|robe|costume set)\b/.test(text);
  }

  function dhcShoppingTargetFromMessage(message){
    const q=dhcNormalizeRetailText(message);
    const specificTheme=dhcSpecificThemeFromMessage(message);
    if(specificTheme){
      const requestedType=dhcProductTypeFromMessage(q)||'costume';
      const noun=({animatronic:'animatronic',decoration:'decoration','party-supplies':'party supplies',prank:'novelty',headwear:'hat',makeup:'makeup',accessory:'accessory'}[requestedType]||requestedType);
      return specificTheme+' '+noun;
    }

    const reverse=q.match(/\b(costume|costumes|outfit|outfits|mask|masks|wig|wigs|animatronic|animatronics|decoration|decorations|prop|props)\s+(?:for\s+)?([a-z0-9'-]{2,35})\b/);
    if(reverse){
      const descriptor=String(reverse[2]||'').replace(/\b(kid|kids|child|children|boy|boys|girl|girls|mens?|womens?|pet|couples?|plus)\b/g,'').trim();
      if(descriptor)return descriptor+' '+reverse[1].replace(/s$/,'');
    }

    const nounMatch=q.match(/\b([a-z0-9' -]{2,55})\s+(costume|costumes|outfit|outfits|mask|masks|wig|wigs|animatronic|animatronics|decoration|decorations|prop|props)\b/);
    if(nounMatch){
      let phrase=(nounMatch[1]+' '+nounMatch[2])
        .replace(/\b(i am|i'm|im|can|could|would|will|you|please|me|looking for|find me|find|show me|pull up|want|need|a|an|some|the|for|my|kids?|children|child|boys?|girls?|mens?|womens?|male|female|pet|couples?|plus size|cheap|cheaper|cute|funny|scary|creepy|realistic)\b/g,' ')
        .replace(/\s+/g,' ').trim();
      if(phrase)return phrase;
    }

    // Natural broad theme requests such as "I need something funny for an 11-year-old boy".
    const themeWords=['witch','vampire','zombie','clown','unicorn','pirate','cowboy','western','fairy','devil','demon','skeleton','reaper','princess','police','cop','doctor','nurse','cat','dog'];
    const found=themeWords.find(x=>new RegExp('\\b'+x+'\\b').test(q));
    if(found)return found+' costume';

    return null;
  }

  function dhcTokenize(v){
    return dhcNormalizeRetailText(v).replace(/[^a-z0-9]+/g,' ').trim().split(/\s+/).filter(Boolean);
  }

  function dhcSynonymQueries(target){
    const q=dhcNormalizeRetailText(target);
    const out=[q];
    Object.entries(DHC_JACK_SYNONYMS).forEach(([key,vals])=>{
      if(q.includes(key)){
        vals.forEach(v=>out.push(q.replace(key,v)));
      }
    });
    return [...new Set(out.filter(Boolean))];
  }

  function dhcProductText(product){
    return dhcNormalizeRetailText([
      product&&product.title,
      product&&product.handle,
      product&&product.vendor,
      product&&product.type
    ].filter(Boolean).join(' '));
  }

  function dhcScoreProduct(product,target,audience,filters={}){
    const title=dhcNormalizeRetailText(product&&product.title);
    const text=dhcProductText(product);
    const targetTokens=dhcTokenize(target).filter(x=>!['costume','costumes','outfit','outfits','mask','masks','wig','wigs','prop','props','decoration','decorations'].includes(x));
    let score=0;
    targetTokens.forEach(t=>{if(new RegExp('\\b'+t+'\\b').test(title))score+=10;else if(text.includes(t))score+=5;});
    if(filters.requiredTheme){if(dhcProductMatchesRequiredTheme(product,filters.requiredTheme))score+=35;else score-=60;}

    if(/\bcostume\b/.test(dhcNormalizeRetailText(target)) && /\bcostume\b/.test(title))score+=5;
    if(audience==='kids')score+=/\b(kid|kids|child|children|boy|boys|girl|girls|youth|toddler)\b/.test(title)?6:0;
    if(audience==='mens')score+=/\b(man|men|mens|male)\b/.test(title)?5:0;
    if(audience==='womens')score+=/\b(woman|women|womens|female|lady)\b/.test(title)?5:0;
    if(audience==='adults')score+=/\b(adult|men|mens|man|women|womens|woman|unisex)\b/.test(title)?7:0;
    if(audience==='pets')score+=/\b(pet|pets|dog|cat|puppy|kitten)\b/.test(title)?6:0;
    if(filters.style&&title.includes(filters.style.replace('-',' ')))score+=3;
    if(filters.color&&new RegExp('\b'+filters.color+'\b').test(title))score+=3;

    // v860 first-pass catalog reasoning from predictive-search facts.
    try{
      if(window.DHCJackCatalogIntelligenceV860){
        const extra=window.DHCJackCatalogIntelligenceV860.scoreProduct(product,target,audience,filters);
        score+=Number(extra&&extra.delta||0);
      }
    }catch(e){}

    // v878 merchandising intelligence: product-class correctness, completeness, budget and live availability.
    try{
      if(window.DHCJackMerchandisingV878){
        const merch=window.DHCJackMerchandisingV878.scoreProduct(product,target,{...filters,wantMain:/\b(costume|outfit|dress|robe|jumpsuit|uniform|cosplay)\b/.test(dhcNormalizeRetailText(target))});
        score+=Number(merch&&merch.delta||0);
      }
    }catch(e){}

    // v861 relationship-aware scoring: main-item requests prefer main product types; explicit accessory requests stay accessory-first.
    try{
      if(window.DHCJackProductRelationshipsV861){
        const rel=window.DHCJackProductRelationshipsV861.relationshipScore(product,target,{wantMain:/\b(costume|outfit|dress|robe|jumpsuit|uniform|cosplay)\b/.test(dhcNormalizeRetailText(target))});
        score+=Number(rel&&rel.delta||0);
      }
    }catch(e){}

    // v862 fit/compatibility scoring: hard audience conflicts and unavailable requested variants should not outrank valid products.
    try{
      if(window.DHCJackFitCompatibilityV862){
        const fc=window.DHCJackFitCompatibilityV862.scoreProduct(product,target,audience,filters);
        score+=Number(fc&&fc.delta||0);
      }
    }catch(e){}

    // Penalize clearly conflicting audiences.
    if(audience==='kids' && /\b(adult|women|womens|men|mens)\b/.test(title) && !/\b(kid|kids|child|children|youth|toddler)\b/.test(title))score-=5;
    if(audience==='adults' && /\b(pet|pets|puppy|kitten|dog clothes|cat clothes|for dogs|for cats)\b/.test(title) && !/\b(adult|men|mens|man|women|womens|woman|unisex)\b/.test(title))score-=45;
    if(audience==='pets' && !/\b(pet|pets|dog|cat|puppy|kitten)\b/.test(title))score-=5;
    return score;
  }

  function dhcHandleFromUrl(url){
    const m=String(url||'').match(/\/products\/([^/?#]+)/);
    return m?m[1]:null;
  }

  async function dhcHydrateProduct(product){
    const handle=product&&product.handle||dhcHandleFromUrl(product&&product.url);
    if(!handle)return {...product,_detail:null};
    try{
      const rootPath=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      const r=await fetch(rootPath+'products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'}});
      if(!r.ok)return {...product,_detail:null};
      const detail=await r.json();
      return {...product,_detail:detail};
    }catch(e){return {...product,_detail:null};}
  }

  function dhcVariantSupportsSize(detail,size){
    if(!size)return true;
    if(!detail||!Array.isArray(detail.variants)||!detail.variants.length)return false;
    const wanted=String(size).toLowerCase();
    return detail.variants.some(v=>{
      const text=[v.title,v.option1,v.option2,v.option3].filter(Boolean).join(' ').toLowerCase();
      return new RegExp('(^|[^a-z0-9])'+wanted.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+'([^a-z0-9]|$)').test(text);
    });
  }

  function dhcVariantSupportsColor(detail,color){
    if(!color||!detail||!Array.isArray(detail.variants))return true;
    const wanted=String(color).toLowerCase();
    return detail.variants.some(v=>[v.title,v.option1,v.option2,v.option3].filter(Boolean).join(' ').toLowerCase().includes(wanted));
  }

  function dhcPriceWithin(detail,max){
    if(!max)return true;
    if(!detail||!Array.isArray(detail.variants)||!detail.variants.length)return false;
    return detail.variants.some(v=>Number(v.price||0)/100<=Number(max));
  }

  function dhcAvailable(detail){
    if(!detail||!Array.isArray(detail.variants)||!detail.variants.length)return false;
    return detail.variants.some(v=>v.available===true);
  }

  function dhcCoreThemeQueries(target){
    const normalized=dhcNormalizeRetailText(target);
    const stop=new Set(['costume','costumes','outfit','outfits','mask','masks','wig','wigs','prop','props','decoration','decorations','adult','kids','kid','child','children','mens','men','womens','women']);
    const tokens=dhcTokenize(normalized).filter(t=>!stop.has(t));
    const out=[normalized];
    if(tokens.length)out.push(tokens.join(' '));
    if(tokens.length>1)out.push(tokens.slice(-2).join(' '));
    if(tokens.length)out.push(tokens[tokens.length-1]);
    return [...new Set(out.filter(Boolean))];
  }

  async function dhcLiveCatalogMatches(target,audience,filters={}){
    if(!target)return [];
    const rootPath=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    const queries=[];
    const core=[...new Set(dhcCoreThemeQueries(target).flatMap(q=>dhcSynonymQueries(q)))];
    core.forEach(q=>{
      if(audience)queries.push((audience+' '+q).trim());
      if(audience==='kids'){
        queries.push(('children '+q).trim(),('girls '+q).trim(),('boys '+q).trim(),('youth '+q).trim());
      }
      if(filters.color)queries.push((filters.color+' '+(audience||'')+' '+q).trim());
      if(filters.style)queries.push((filters.style+' '+(audience||'')+' '+q).trim());
      if(filters.occasion)queries.push(((audience||'')+' '+q+' '+filters.occasion).trim());
      queries.push(q);
    });

    const seen=new Map();
    for(const q of [...new Set(queries)].slice(0,14)){
      try{
        const url=rootPath+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=10';
        const r=await fetch(url,{headers:{Accept:'application/json'}});
        if(!r.ok)continue;
        const data=await r.json();
        const products=data&&data.resources&&data.resources.results&&data.resources.results.products||[];
        products.forEach(product=>{
          const key=product.url||product.handle||product.title;
          if(!key)return;
          const score=dhcScoreProduct(product,target,audience,filters);
          const previous=seen.get(key);
          if(!previous||score>previous.score)seen.set(key,{product,score});
        });
      }catch(e){}
    }

    // v1021: supplement live Shopify predictive search with the cleaned 6,061-product Jack multi-catalog index.
    // The static index never replaces live Shopify product facts; candidates are hydrated from Shopify before final use.
    try{
      if(window.DHCJackMultiCatalogSearch){
        const staticQuery=[audience,target].filter(Boolean).join(' ').trim()||target;
        const staticMatches=window.DHCJackMultiCatalogSearch(staticQuery,{limit:16})||[];
        staticMatches.forEach(hit=>{
          const p=hit&&hit.product||hit;
          if(!p||!p.handle)return;
          const key=p.url||('/products/'+p.handle);
          const stub={title:p.title,handle:p.handle,url:key,type:p.type||'',vendor:''};
          const liveScore=dhcScoreProduct(stub,target,audience,filters);
          const staticScore=Number(hit&&hit.score||0);
          const score=liveScore+Math.min(30,staticScore/2);
          const previous=seen.get(key);
          if(!previous||score>previous.score)seen.set(key,{product:stub,score,source:'multi-catalog-v1021'});
        });
      }
    }catch(e){}

    let ranked=[...seen.values()].sort((a,b)=>b.score-a.score).filter(x=>x.score>=8).slice(0,12);
    let hydrated=await Promise.all(ranked.map(async x=>({...x,product:await dhcHydrateProduct(x.product)})));
    hydrated=hydrated.map(x=>{
      try{
        if(window.DHCJackCatalogIntelligenceV860){
          const extra=window.DHCJackCatalogIntelligenceV860.scoreProduct(x.product,target,audience,filters);
          let adjusted=x.score+Number(extra&&extra.delta||0);
          let fitCompatibility=null;
          try{
            if(window.DHCJackFitCompatibilityV862){
              fitCompatibility=window.DHCJackFitCompatibilityV862.scoreProduct(x.product,target,audience,filters);
              adjusted+=Number(fitCompatibility&&fitCompatibility.delta||0);
            }
          }catch(e){}
          return {...x,score:adjusted,_catalogProfile:extra&&extra.profile||null,_fitCompatibility:fitCompatibility};
        }
      }catch(e){}
      return x;
    }).sort((a,b)=>b.score-a.score);
    hydrated=hydrated.filter(x=>{
      const d=x.product._detail;
      if(filters.requiredTheme&&!dhcProductMatchesRequiredTheme(x.product,filters.requiredTheme))return false;
      if(filters.fullCostume&&!dhcProductLooksLikeFullCostume(x.product))return false;
      if(filters.size&&!dhcVariantSupportsSize(d,filters.size))return false;
      if(filters.color&&!dhcVariantSupportsColor(d,filters.color))return false;
      if(filters.budgetMax&&!dhcPriceWithin(d,filters.budgetMax))return false;
      if(filters.availabilityOnly&&!dhcAvailable(d))return false;
      return true;
    });

    // v878: keep the final shortlist useful and reduce near-duplicate recommendations.
    try{
      if(window.DHCJackMerchandisingV878){
        hydrated=window.DHCJackMerchandisingV878.diversify(hydrated,Math.min(5,hydrated.length));
      }
    }catch(e){}

    if(filters.cheaper){
      hydrated.sort((a,b)=>{
        const pa=Math.min(...((a.product._detail&&a.product._detail.variants)||[]).map(v=>Number(v.price||Infinity)));
        const pb=Math.min(...((b.product._detail&&b.product._detail.variants)||[]).map(v=>Number(v.price||Infinity)));
        return pa-pb || b.score-a.score;
      });
    }
    return hydrated.slice(0,3).map(x=>x.product);
  }

  function dhcProductPriceText(product){
    const d=product&&product._detail;
    if(!d||!Array.isArray(d.variants)||!d.variants.length)return '';
    const prices=d.variants.map(v=>Number(v.price||0)).filter(x=>x>0);
    if(!prices.length)return '';
    const min=Math.min(...prices),max=Math.max(...prices);
    const money=c=>'$'+(c/100).toFixed(2);
    return min===max?money(min):money(min)+'–'+money(max);
  }

  function dhcCatalogReply(products,target,audience,filters={}){
    if(!products.length)return '';
    const audienceText=audience==='kids'?'kids ':audience==='adults'?'adult ':audience?audience+' ':'';
    let out=products.length===1
      ? 'I found a strong direct product match for '+audienceText+target+'.'
      : 'I found the strongest direct product matches for '+audienceText+target+'.';

    products.forEach((p,i)=>{
      const d=p._detail||{};
      const price=dhcProductPriceText(p);
      const available=d&&Array.isArray(d.variants)?d.variants.some(v=>v.available===true):null;
      out+='\n\n'+(i+1)+'. '+String(p.title||d.title||'Matching product');
      if(price)out+=' — '+price;
      if(available===true)out+=' — available';
      const liveUrl=String(p.url||d.url||p.product_url||d.product_url||p.productUrl||d.productUrl||'').trim(); if(liveUrl)out+='\n'+liveUrl;
    });

    if(filters.size)out+='\n\nI kept only products where live variant data verified size '+filters.size+'.';
    if(filters.budgetMax)out+='\nI kept results at or under $'+filters.budgetMax+' where live variant pricing supported that filter.';
    if(filters.availabilityOnly)out+='\nI kept only products with at least one currently available live variant.';
    if(filters.deliverySensitive)out+='\nFor delivery timing, I am not ranking by speed unless a verified product/checkout delivery estimate is available. Check the live estimate before checkout.';
    out+='\n\nI’m showing direct product matches first instead of dropping you into a mixed collection.';
    return out;
  }

  function dhcCompleteLookReply(target,audience){
    const base=String(target||'').replace(/\b(costume|costumes)\b/g,'').trim();
    if(!base)return '';
    let queries=[];
    try{if(window.DHCJackProductRelationshipsV861){queries=window.DHCJackProductRelationshipsV861.complementQueries(base,{mode:'build-look'});}}catch(e){}
    if(!queries.length)queries=['accessories','makeup','props'];
    let out='\n\nComplete the look:';
    queries.slice(0,3).forEach(q=>{const search=[audience,base,q].filter(Boolean).join(' ').trim();out+='\n'+q.replace(/\b\w/g,c=>c.toUpperCase())+': /search?q='+encodeURIComponent(search)+'&type=product';});
    return out;
  }

  async function dhcTryExactCatalogLookup(message){
    try{
      if(window.DHCJackProductComparisonV865 && /\b(compare|which one|which is|which should|better|best value|cheaper|cheapest|in stock|has (xl|large|medium|small)|fullest|more complete)\b/i.test(String(message||'')) && Array.isArray(jackCatalogState.lastProductDetails) && jackCatalogState.lastProductDetails.length>=2){
        const shopper={target:jackCatalogState.target,audience:jackCatalogState.audience,size:jackCatalogState.size,budgetMax:jackCatalogState.budgetMax,style:jackCatalogState.style,color:jackCatalogState.color,occasion:jackCatalogState.occasion};
        const comparison=window.DHCJackProductComparisonV865.reply(jackCatalogState.lastProductDetails,shopper,message);
        if(comparison)return comparison;
      }
    }catch(e){}
    // B193: never transform an exact-product fit question into a product search.
    if(window.DHCSizeHelpV193){
      var sizingReply=window.DHCSizeHelpV193.reply(message);
      if(sizingReply)return sizingReply;
    }
    // B204: exact-intent live search, with the B203 training and relevance gate.
    if(window.DHCGusSearchV204){var trained=await window.DHCGusSearchV204.answer(message);if(trained)return trained;}
    const audience=dhcAudienceFromMessage(message);
    const filters=dhcExtractRetailFilters(message);
    const specificTheme=dhcSpecificThemeFromMessage(message);
    if(specificTheme)filters.requiredTheme=specificTheme;
    let target=dhcShoppingTargetFromMessage(message);

    if(!target && filters.style && audience){
      target=filters.style.replace('-',' ')+' costume';
    }

    if(filters.similar && !target){
      target=jackCatalogState.target || String(root.dataset.jackPageTitle||'').trim() || null;
    }
    if(target)jackCatalogState.target=target;
    if(audience)jackCatalogState.audience=audience;

    ['size','budgetMax','style','color','occasion'].forEach(k=>{if(filters[k])jackCatalogState[k]=filters[k];});
    ['availabilityOnly','deliverySensitive','completeLook'].forEach(k=>{if(filters[k])jackCatalogState[k]=true;});

    const shortAudience=/^\s*(kid|kids|child|children|boy|girl|man|men|woman|women|pet|dog|cat|couple|couples|plus|plus size)\s*$/i.test(String(message||''));
    const hasConcreteTarget=!!target || (shortAudience&&!!jackCatalogState.target) || (filters.similar&&!!jackCatalogState.target);
    if(!hasConcreteTarget)return null;

    const effectiveTarget=target||jackCatalogState.target;
    const effectiveAudience=audience||jackCatalogState.audience;
    if(!effectiveTarget)return null;

    const effectiveFilters={
      size:filters.size||jackCatalogState.size,
      budgetMax:filters.budgetMax||jackCatalogState.budgetMax,
      style:filters.style||jackCatalogState.style,
      color:filters.color||jackCatalogState.color,
      occasion:filters.occasion||jackCatalogState.occasion,
      availabilityOnly:filters.availabilityOnly||false,
      deliverySensitive:filters.deliverySensitive||false,
      completeLook:filters.completeLook||false,
      fullCostume:filters.fullCostume||false,
      accessoryOnly:filters.accessoryOnly||false,
      cheaper:filters.cheaper||false,
      requiredTheme:filters.requiredTheme||null
    };

    let products=await dhcLiveCatalogMatches(effectiveTarget,effectiveAudience,effectiveFilters);
    let recoveryStage=null;

    // A specific requested theme is a primary relevance constraint. Never let generic recovery drop it.
    if(!products.length && effectiveFilters.requiredTheme){
      const familyTargets=dhcThemeRecoveryTargets(effectiveFilters.requiredTheme);
      for(const familyTarget of familyTargets){
        const familyFilters={...effectiveFilters,requiredTheme:null};
        const attempt=await dhcLiveCatalogMatches(familyTarget,effectiveAudience,familyFilters);
        if(attempt&&attempt.length){
          products=attempt;
          recoveryStage={kind:'theme-family',target:familyTarget,filters:familyFilters,originalTheme:effectiveFilters.requiredTheme};
          break;
        }
      }
      if(!products.length){
        let constraints=[];
        if(effectiveAudience)constraints.push(effectiveAudience);
        if(effectiveFilters.size)constraints.push('size '+effectiveFilters.size);
        if(effectiveFilters.budgetMax)constraints.push('at or under $'+effectiveFilters.budgetMax);
        if(effectiveFilters.fullCostume)constraints.push('full costume');
        if(effectiveFilters.availabilityOnly)constraints.push('currently available');
        return 'I couldn’t verify a direct '+effectiveFilters.requiredTheme+' match'+(constraints.length?' that also meets '+constraints.join(', '):'')+'. I’m not going to call unrelated products direct matches. You can loosen one constraint or I can broaden to a nearby theme.';
      }
    }else if(!products.length){
      try{
        if(window.DHCJackSearchRecoveryV867){
          const recovery=window.DHCJackSearchRecoveryV867.plan(message,effectiveTarget,effectiveAudience,effectiveFilters);
          for(const stage of (recovery.stages||[])){
            const attempt=await dhcLiveCatalogMatches(stage.target,effectiveAudience,stage.filters||effectiveFilters);
            if(attempt&&attempt.length){products=attempt;recoveryStage=stage;break;}
          }
        }
      }catch(e){}
    }
    if(!products.length)return null;
    jackCatalogState.lastProducts=products.map(p=>({title:p.title,url:p.url,handle:p.handle}));
    jackCatalogState.lastProductDetails=products.slice(0,3);
    let reply=dhcCatalogReply(products,recoveryStage?recoveryStage.target:effectiveTarget,effectiveAudience,recoveryStage?(recoveryStage.filters||effectiveFilters):effectiveFilters);
    if(recoveryStage){
      let note='';
      if(recoveryStage.kind==='theme-family')note='I couldn’t verify a direct '+recoveryStage.originalTheme+' match, so I kept the hard shopping constraints and broadened only to the closest related costume family.';
      else if(window.DHCJackSearchRecoveryV867)note=window.DHCJackSearchRecoveryV867.explain(recoveryStage)||'';
      if(note)reply=note+'\n\n'+reply;
    }
    if(effectiveFilters.completeLook)reply+=dhcCompleteLookReply(effectiveTarget,effectiveAudience);
    return reply;
  }

  function dhcLocalShoppingFallback(message){
    try{
      if(window.DHCJackOffline&&typeof window.DHCJackOffline.answer==='function'){
        const reply=window.DHCJackOffline.answer(message);
        if(reply)return reply;
      }
    }catch(e){}

    const audience=dhcAudienceFromMessage(message)||jackCatalogState.audience;
    const target=dhcShoppingTargetFromMessage(message)||jackCatalogState.target;
    if(target){
      const q=[audience,target].filter(Boolean).join(' ').trim();
      return 'I can still help even though the live assistant connection is unavailable. Here are the closest store results for '+q+':\n/search?q='+encodeURIComponent(q)+'&type=product';
    }
    return 'I can still help with products, sizing, orders, shipping, and returns. Tell me what you want to find and I’ll use the storefront tools available right now.';
  }

  let dhcTranscript=dhcLoadTranscript();

  let add=(text,role,persist=true)=>{
    const row=document.createElement('div');row.className='dhc-support-row '+(role==='user'?'is-user':'is-agent');
    if(role!=='user'){const img=document.createElement('img');img.className='dhc-support-message-avatar';img.src=msgs.dataset.jackAvatar||'';img.alt='';img.width=34;img.height=34;row.appendChild(img)}
    const d=document.createElement('div');d.className='dhc-support-msg '+(role==='user'?'is-user':'is-agent');
    const value=String(text||''),urlRe=/(https?:\/\/[^\s]+|\/search\?[^\s]+|\/(?:products|search|collections|pages|policies)\/[^\s]*)/g;let last=0,m;
    while((m=urlRe.exec(value))){
      if(m.index>last)d.appendChild(document.createTextNode(value.slice(last,m.index)));
      const a=document.createElement('a');
      a.href=m[0];
      a.target=m[0].indexOf('http')===0?'_blank':'_self';
      a.rel='noopener';
      const isCarrier=m[0].indexOf('http')===0;
      const isProduct=m[0].indexOf('/products/')===0;
      const isSearch=m[0].indexOf('/search?')===0||m[0].indexOf('/search/')===0;
      a.textContent=isCarrier?'View carrier tracking':isProduct?'View product':isSearch?'Open matching products':'Open';
      a.className='dhc-jack-tracking-link';
      d.appendChild(a);
      last=m.index+m[0].length;
    }
    if(last<value.length)d.appendChild(document.createTextNode(value.slice(last)));
    row.appendChild(d);msgs.appendChild(row);msgs.scrollTop=msgs.scrollHeight;

    if(persist){
      dhcTranscript.push({role:role==='user'?'user':'agent',text:value,at:Date.now()});
      dhcTranscript=dhcTranscript.slice(-80);
      dhcSaveTranscript(dhcTranscript);
    }
  };

  // Restore the exact visible conversation after navigating to another store page.
  if(dhcTranscript.length){
    msgs.innerHTML='';
    dhcTranscript.forEach(x=>add(x.text,x.role,false));
  }

  function dhcOpenChat(){
    if(!panel)return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden','false');
    root.classList.add('dhc-jack-is-open');
    try{sessionStorage.setItem(DHC_CHAT_OPEN_KEY,'1')}catch(e){}
  }

  function dhcEndChat(){
    if(window.DHCSizeHelpV193)window.DHCSizeHelpV193.reset();
    if(panel){
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden','true');
      root.classList.remove('dhc-jack-is-open');
    }
    dhcClearConversation();
    dhcTranscript=[];
  }

  if(open && panel) open.addEventListener('click',dhcOpenChat);

  // Per requested behavior: X ends this conversation.
  if(close && panel) close.addEventListener('click',dhcEndChat);
  if(outerClose && panel) outerClose.addEventListener('click',dhcEndChat);

  // If Jack was open when the shopper followed a product/search link, reopen him.
  try{
    if(sessionStorage.getItem(DHC_CHAT_OPEN_KEY)==='1')dhcOpenChat();
  }catch(e){}

  if(!form || !msgs) return;
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('[data-dhc-size-help-v193]');
    if(!btn)return;
    e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
    var service=window.DHCSizeHelpV193,ctx=service&&service.context();
    if(!service||!ctx)return;
    if(typeof window.DHCOpenJack==='function')window.DHCOpenJack();else dhcOpenChat();
    var response=service.begin(ctx);
    add('Help me choose a size for '+ctx.title+'.','user');
    add(response,'agent');
    var input=form.elements.message;
    if(input){input.value='';input.placeholder='Ask Gus about '+ctx.title;try{input.focus()}catch(_){}}
  },true);
  // Avoid consecutive identical assistant messages caused by duplicate response layers.
  var dhcOriginalAdd=add;
  add=function(text,role,persist){
    if(role!=='user'&&dhcTranscript.length){
      var last=dhcTranscript[dhcTranscript.length-1];
      if(last.role==='agent'&&last.text===String(text||'')&&Date.now()-last.at<30000)return;
    }
    return dhcOriginalAdd(text,role,persist);
  };
  form.addEventListener('submit',async e=>{
    e.preventDefault();const input=form.elements.message;const message=input.value.trim();if(!message)return;
    const silentPrompt=form.dataset.dhcJackSilentPrompt==='1';
    try{delete form.dataset.dhcJackSilentPrompt}catch(_){form.dataset.dhcJackSilentPrompt=''}
    if(!silentPrompt)add(message,'user');input.value='';input.disabled=true;
    const wait=document.createElement('div');wait.className='dhc-support-row is-agent';const waitImg=document.createElement('img');waitImg.className='dhc-support-message-avatar';waitImg.src=msgs.dataset.jackAvatar||'';waitImg.alt='';waitImg.width=34;waitImg.height=34;const waitMsg=document.createElement('div');waitMsg.className='dhc-support-msg is-agent is-typing';waitMsg.textContent='Checking that for you…';wait.appendChild(waitImg);wait.appendChild(waitMsg);msgs.appendChild(wait);
    try{
      const sizeReply=window.DHCSizeHelpV193&&window.DHCSizeHelpV193.reply(message);
      if(sizeReply){wait.remove();add(sizeReply,'agent');return;}
      const catalogReply=await dhcTryExactCatalogLookup(message);
      if(catalogReply){
        wait.remove();
        add(catalogReply,'agent');
        return;
      }

      let j=null;
      if(window.DHCJackBackend && root.dataset.jackOfflineFirst!=='true'){
        try{
          j=await window.DHCJackBackend.chat(message,{
            page:root.dataset.jackPageUrl||window.location.href,
            productHandle:root.dataset.jackProductHandle||undefined
          });
          if(j&&j.ok!==false){
            conversationId=j.conversationId||j.sessionId||conversationId;
            if(conversationId)sessionStorage.setItem(DHC_CHAT_ID_KEY,conversationId);
            try{window.dispatchEvent(new CustomEvent('dhc:jack-v2-response',{detail:j}))}catch(_){ }
          }else{j=null;}
        }catch(_){j=null;}
      }
      if(!j){
        const r=await fetch((root.dataset.jackEndpoint||'/apps/dhc-support'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({
          message,
          conversationId,
          assistantMode:'costume_concierge',
          trainingVersion:root.dataset.jackTrainingVersion||'v1017',
          pageContext:{
            type:root.dataset.jackPageType||'',
            title:root.dataset.jackPageTitle||'',
            url:root.dataset.jackPageUrl||window.location.href
          },
          shopperProfile:window.DHCJackProfile||null,
          conciergeRules:[
            'Ask concise follow-up questions when the shopper is unsure.',
            'Recommend costume ideas by audience, vibe, budget, effort, occasion, size needs, and timing.',
            'Prefer products and search destinations from Discount Halloween City.',
            'Give direct store links or search links whenever possible.',
            'Offer complete-the-look accessories when useful.',
            'Never invent availability, price, size, brand, character, or licensing information.',
            'For children, keep recommendations age-appropriate.',
            'If a customer is stuck, provide 3 strong options instead of an overwhelming list.'
          ]
        })});
        j=await r.json();
        if(!r.ok||!j.ok)throw new Error(j.error||'Support unavailable');
        conversationId=j.conversationId||j.sessionId||conversationId;
        if(conversationId)sessionStorage.setItem(DHC_CHAT_ID_KEY,conversationId);
      }
      wait.remove();
      add(j.reply||j.text||j.answer||j.message||'I’m here to help.','agent');
    }catch(err){
      wait.remove();
      add(dhcLocalShoppingFallback(message),'agent');
    }
    finally{input.disabled=false;input.focus()}
  });
 });
});

/* v27 Halloween Concierge UX */
document.addEventListener('DOMContentLoaded',()=>{
  const widget=document.querySelector('[data-dhc-support]');
  if(!widget) return;
  const panel=widget.querySelector('[data-support-panel]');
  const form=widget.querySelector('[data-support-form]');
  const input=form?.elements?.message;

  document.querySelectorAll('[data-support-header-open]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      panel?.classList.add('is-open');
      panel?.setAttribute('aria-hidden','false');
      setTimeout(()=>input?.focus(),50);
    });
  });

  widget.querySelectorAll('[data-support-prompt]').forEach(btn=>{
    btn.addEventListener('click',e=>{
      if(!input||!form) return;
      e.preventDefault();

      const prompt=String(btn.getAttribute('data-support-prompt')||'').trim();
      if(!prompt)return;

      panel?.classList.add('is-open');
      panel?.setAttribute('aria-hidden','false');

      // Quick actions are internal flow instructions, not customer-authored chat text.
      form.dataset.dhcJackSilentPrompt='1';
      input.value=prompt;
      try{
        form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
      }finally{
        setTimeout(()=>{
          if(input.value===prompt)input.value='';
          if(form.dataset.dhcJackSilentPrompt==='1'){
            try{delete form.dataset.dhcJackSilentPrompt}catch(_){form.dataset.dhcJackSilentPrompt=''}
          }
        },0);
      }
    });
  });
});

/* v36 Mobile header search focus */
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-mobile-search-focus]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const input=document.querySelector('.dhc-header .dhc-search input[type="search"]');
      if(input){input.focus();input.scrollIntoView({block:'nearest',behavior:'smooth'});}
    });
  });
});

/* v43 Back-to-top interaction */
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-back-to-top]').forEach(btn=>{
    btn.addEventListener('click',()=>window.scrollTo({top:0,behavior:'smooth'}));
  });
});

/* v44 Product gallery */
document.addEventListener('DOMContentLoaded',()=>{
 document.querySelectorAll('[data-product-gallery]').forEach(root=>{
  const items=[...root.querySelectorAll('[data-media-id]')], thumbs=[...root.querySelectorAll('[data-product-thumb]')];
  thumbs.forEach(btn=>btn.addEventListener('click',()=>{
   const id=btn.dataset.productThumb;items.forEach(x=>x.classList.toggle('is-active',x.dataset.mediaId===id));thumbs.forEach(x=>x.classList.toggle('is-active',x===btn));
  }));
 });
});

/* v1013 checkout-start marker */
document.addEventListener('click',function(e){
  var checkout=e.target.closest&&e.target.closest('[data-dhc-checkout]');
  if(!checkout)return;
  try{localStorage.setItem('dhc_checkout_started_at',String(Date.now()))}catch(_){}
},true);

/* v44 Returning-shopper cart recovery backup */
document.addEventListener('DOMContentLoaded',async()=>{
 const KEY='dhc_cart_backup_v1', CHECKOUT='dhc_checkout_started_at';
 const root=window.Shopify?.routes?.root||'/';
 function save(v){try{localStorage.setItem(KEY,JSON.stringify(v))}catch{}}
 function load(){try{return JSON.parse(localStorage.getItem(KEY)||'null')}catch{return null}}
 document.querySelectorAll('[data-dhc-checkout]').forEach(x=>x.addEventListener('click',()=>{try{localStorage.setItem(CHECKOUT,String(Date.now()))}catch{}}));
 try{
  const r=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});if(!r.ok)return;const cart=await r.json();
  if(cart.item_count>0){save({savedAt:Date.now(),items:cart.items.map(x=>({id:x.variant_id,quantity:x.quantity}))});return}
  const backup=load(); if(!backup?.items?.length)return;
  if(Date.now()-Number(backup.savedAt||0)>7*24*60*60*1000){localStorage.removeItem(KEY);return}
  const checkoutAt=Number(localStorage.getItem(CHECKOUT)||0);if(checkoutAt&&Date.now()-checkoutAt<24*60*60*1000)return;
  const bar=document.createElement('div');bar.className='dhc-cart-recovery';bar.innerHTML='<span>You had Halloween items in your cart. Want to restore them?</span><button class="restore" type="button">RESTORE CART</button><button class="dismiss" type="button">NOT NOW</button>';document.body.appendChild(bar);
  bar.querySelector('.dismiss').addEventListener('click',()=>bar.remove());
  bar.querySelector('.restore').addEventListener('click',async()=>{const b=bar.querySelector('.restore');b.disabled=true;b.textContent='RESTORING…';try{const rr=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:backup.items})});if(!rr.ok)throw new Error();location.href=root+'cart'}catch{b.disabled=false;b.textContent='TRY AGAIN'}});
 }catch{}
});


/* DHC v70 functional navigation controller */
document.addEventListener('DOMContentLoaded', function () {

});


/* v67O functional bundle builder */
(function(){
  function money(cents){
    try{
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US',{
        style:'currency',
        currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      }).format((Number(cents)||0)/100);
    }catch(e){
      return '$'+((Number(cents)||0)/100).toFixed(2);
    }
  }

  function initBundle(root){
    if(!root || root.dataset.bundleReady==='1') return;
    root.dataset.bundleReady='1';

    var checks=[].slice.call(root.querySelectorAll('[data-bundle-check]'));
    var add=root.querySelector('[data-bundle-add]');
    var count=root.querySelector('[data-bundle-count]');
    var total=root.querySelector('[data-bundle-total]');
    var status=root.querySelector('[data-bundle-status]');
    var viewCart=root.querySelector('[data-dhc-bundle-view-cart]');

    function selectedVariant(item){
      return item.querySelector('[data-bundle-variant]');
    }

    function updateItemPrice(item){
      var variant=selectedVariant(item);
      var price=0;
      if(variant){
        if(variant.tagName==='SELECT'){
          var opt=variant.options[variant.selectedIndex];
          price=opt ? Number(opt.dataset.price || 0) : 0;
        }else{
          price=Number(variant.dataset.price || 0);
        }
      }
      var el=item.querySelector('[data-bundle-item-price]');
      if(el) el.textContent=money(price);
      return price;
    }

    function update(){
      var n=0, cents=0;
      checks.forEach(function(cb){
        var item=cb.closest('[data-bundle-item]');
        updateItemPrice(item);
        if(cb.checked && !cb.disabled){
          n++;
          cents+=updateItemPrice(item);
        }
      });
      if(count) count.textContent=String(n);
      if(total) total.textContent=money(cents);
      if(add) add.disabled=n===0;
    }

    root.addEventListener('change',function(e){
      if(e.target.matches('[data-bundle-check],[data-bundle-variant]')) update();
    });

    if(add){
      add.addEventListener('click',function(){
        var items=[];
        checks.forEach(function(cb){
          if(!cb.checked || cb.disabled) return;
          var item=cb.closest('[data-bundle-item]');
          var variant=selectedVariant(item);
          if(!variant) return;
          var inventoryChoice=variant;
          if(variant.tagName==='SELECT'){
            if(variant.selectedIndex<0) return;
            inventoryChoice=variant.options[variant.selectedIndex];
          }
          if(!inventoryChoice || inventoryChoice.disabled || String(inventoryChoice.dataset.dhcStrictAvailable||'true')==='false') return;
          if(String(inventoryChoice.dataset.inventoryManaged||'false')==='true' && Number(inventoryChoice.dataset.inventoryQuantity||0)<=0) return;
          var id=variant.value;
          if(id) items.push({id:Number(id),quantity:1});
        });

        if(!items.length) return;

        add.disabled=true;
        if(viewCart) viewCart.hidden=true;
        if(status){
          status.className='dhc-bundle-builder__status';
          status.textContent='Adding your bundle…';
        }

        fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:items})
        })
        .then(function(r){
          if(!r.ok) return r.json().then(function(x){throw new Error(x.description || 'Unable to add bundle');});
          return r.json();
        })
        .then(function(){
          if(status){
            status.className='dhc-bundle-builder__status is-success';
            status.textContent='Bundle added to cart.';
          }
          if(viewCart){
            viewCart.href=(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/')+'cart';
            viewCart.hidden=false;
          }
          add.disabled=false;
          add.textContent='ADDED ✓';
          document.dispatchEvent(new CustomEvent('dhc:cart:updated',{detail:{source:'bundle-add'}}));
          window.setTimeout(function(){ add.textContent='ADD BUNDLE TO CART'; },1600);
        })
        .catch(function(err){
          add.disabled=false;
          if(status){
            status.className='dhc-bundle-builder__status is-error';
            status.textContent=err.message || 'Unable to add bundle. Please try again.';
          }
        });
      });
    }

    update();
  }

  function boot(){
    document.querySelectorAll('[data-dhc-bundle]').forEach(initBundle);
  }

  document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();


/* B221: desktop mega menu is managed by dhc-b221-navigation.js. */

/* v67R single global mobile drawer controller */
(function(){
  function initDHCMobileDrawer(drawer){
    if(!drawer || drawer.dataset.dhcDrawerReady==='1') return;
    drawer.dataset.dhcDrawerReady='1';

    var overlay=document.querySelector('[data-mobile-drawer-overlay]');
    var openers=Array.prototype.slice.call(document.querySelectorAll('[data-mobile-menu-open]'));
    var closers=Array.prototype.slice.call(drawer.querySelectorAll('[data-mobile-menu-close]'));
    var lastOpener=null;

    function setOpen(open){
      drawer.classList.toggle('is-open',open);
      drawer.setAttribute('aria-hidden',open?'false':'true');

      if(overlay){
        overlay.hidden=!open;
        overlay.classList.toggle('is-open',open);
      }

      document.body.classList.toggle('dhc-menu-open',open);
      document.documentElement.classList.toggle('dhc-menu-open',open);

      openers.forEach(function(btn){
        btn.setAttribute('aria-expanded',open?'true':'false');
      });

      if(open){
        var closeBtn=drawer.querySelector('[data-mobile-menu-close]');
        if(closeBtn) window.setTimeout(function(){ closeBtn.focus(); },0);
      }else if(lastOpener){
        window.setTimeout(function(){ lastOpener.focus(); },0);
      }
    }

    function openDrawer(e){
      if(e) e.preventDefault();
      lastOpener=e && e.currentTarget ? e.currentTarget : null;
      setOpen(true);
    }

    function closeDrawer(e){
      if(e) e.preventDefault();
      setOpen(false);
    }

    openers.forEach(function(btn){
      btn.addEventListener('click',openDrawer);
    });

    closers.forEach(function(btn){
      btn.addEventListener('click',closeDrawer);
    });

    if(overlay){
      overlay.addEventListener('click',closeDrawer);
    }

    drawer.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click',function(){
        setOpen(false);
      });
    });

    drawer.querySelectorAll('[data-mobile-sub-toggle]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var id=btn.getAttribute('aria-controls');
        var panel=id ? document.getElementById(id) : null;
        if(!panel) return;
        var expanded=btn.getAttribute('aria-expanded')==='true';
        btn.setAttribute('aria-expanded',expanded?'false':'true');
        panel.classList.toggle('is-open',!expanded);
      });
    });

    document.addEventListener('keydown',function(e){
      if(e.key==='Escape' && drawer.classList.contains('is-open')){
        closeDrawer(e);
      }
    });

    // Defensive close if viewport grows to desktop.
    window.addEventListener('resize',function(){
      if(window.innerWidth>=750 && drawer.classList.contains('is-open')){
        setOpen(false);
      }
    });

    // Always start closed, including Theme Editor page changes.
    setOpen(false);
  }

  function bootDHCMobileDrawer(){
    document.querySelectorAll('[data-mobile-drawer]').forEach(initDHCMobileDrawer);
  }

  document.addEventListener('DOMContentLoaded',bootDHCMobileDrawer);
  document.addEventListener('shopify:section:load',bootDHCMobileDrawer);
})();


/* v67U global quick add */
(function(){
  function initQuickAdd(root){
    root=root||document;
    root.querySelectorAll('[data-dhc-quick-add]').forEach(function(btn){
      if(btn.dataset.quickReady==='1') return;
      btn.dataset.quickReady='1';

      btn.addEventListener('click',function(){
        var id=Number(btn.dataset.variantId||0);
        var inventoryManaged=String(btn.dataset.inventoryManaged||'false')==='true';
        var inventoryQuantity=Number(btn.dataset.inventoryQuantity||0);
        if(!id || btn.disabled || String(btn.dataset.dhcStrictAvailable||'true')==='false' || (inventoryManaged && inventoryQuantity<=0)) return;

        var wrap=btn.closest('[data-dhc-product-cta]') || btn.parentElement;
        var status=wrap ? wrap.querySelector('[data-dhc-quick-status]') : null;
        var original=btn.textContent;

        btn.disabled=true;
        btn.classList.add('is-loading');
        btn.textContent='ADDING…';
        if(status){
          status.className='dhc-product-cta__status';
          status.textContent='';
        }

        fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:id,quantity:1}]})
        })
        .then(function(r){
          if(!r.ok) return r.json().then(function(x){throw new Error(x.description||'Unable to add item');});
          return r.json();
        })
        .then(function(){
          if(inventoryManaged){
            inventoryQuantity=Math.max(0,inventoryQuantity-1);
            btn.dataset.inventoryQuantity=String(inventoryQuantity);
            if(inventoryQuantity<=0){
              btn.dataset.dhcStrictAvailable='false';
            }
          }
          btn.disabled=inventoryManaged && inventoryQuantity<=0;
          btn.classList.remove('is-loading');
          btn.textContent='ADDED ✓';
          if(status){
            status.className='dhc-product-cta__status is-success';
            status.textContent='Added to cart';
          }

          document.dispatchEvent(new CustomEvent('dhc:cart:updated'));

          window.setTimeout(function(){
            btn.textContent=original;
            if(status) status.textContent='';
          },1800);
        })
        .catch(function(err){
          btn.disabled=inventoryManaged && Number(btn.dataset.inventoryQuantity||0)<=0;
          btn.classList.remove('is-loading');
          btn.textContent=original;
          if(status){
            status.className='dhc-product-cta__status is-error';
            status.textContent=err.message||'Please try again';
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded',function(){initQuickAdd(document)});
  document.addEventListener('shopify:section:load',function(e){initQuickAdd(e.target)});
})();


/* v680 collection sort */
(function(){
  function initCollectionSort(root){
    (root||document).querySelectorAll('[data-dhc-sort]').forEach(function(select){
      if(select.dataset.dhcSortReady==='1') return;
      select.dataset.dhcSortReady='1';
      select.addEventListener('change',function(){
        var url=new URL(window.location.href);
        if(select.value) url.searchParams.set('sort_by',select.value);
        else url.searchParams.delete('sort_by');
        window.location.href=url.toString();
      });
    });
  }
  document.addEventListener('DOMContentLoaded',function(){initCollectionSort(document)});
  document.addEventListener('shopify:section:load',function(e){initCollectionSort(e.target)});
})();


/* v682 Jack Costume Concierge */
(function(){
  var PROFILE_KEY='dhc_jack_costume_profile_v1';

  function encode(q){return encodeURIComponent(q);}
  function searchUrl(q){
    return '/search?q='+encode(q)+'&type=product';
  }

  var vibeIdeas={
    scary:['vampire costume','scary clown costume','skeleton costume'],
    funny:['inflatable costume','food costume','animal costume'],
    classic:['witch costume','vampire costume','skeleton costume'],
    movie:['movie costume','gaming costume','superhero costume'],
    unique:['steampunk costume','plague doctor costume','medieval costume'],
    easy:['costume accessories','cape costume','mask costume'],
    glam:['glam witch costume','devil costume','gothic costume'],
    surprise:['pirate costume','scarecrow costume','ninja costume']
  };

  var audienceTerms={
    women:"women's",
    men:"men's",
    kids:"kids",
    couples:"couples",
    pet:"pet",
    adult:"adult"
  };

  function budgetCopy(v){
    return ({
      'under-30':'under $30',
      '30-60':'around $30–$60',
      '60-100':'around $60–$100',
      '100-plus':'$100+',
      'any':'any budget'
    })[v]||'any budget';
  }

  function effortTerm(v){
    return ({
      full:'full costume',
      simple:'easy costume',
      accessories:'accessories',
      any:'costume'
    })[v]||'costume';
  }

  function buildQuery(profile,idea){
    var parts=[];
    var aud=audienceTerms[profile.audience]||'';
    if(aud) parts.push(aud);
    parts.push(idea);
    if(profile.effort==='accessories') parts.push('accessories');
    return parts.join(' ').replace(/\s+/g,' ').trim();
  }

  function recommendations(profile){
    var ideas=(vibeIdeas[profile.vibe]||vibeIdeas.surprise).slice(0,3);
    // Do not surface adult glam ideas to kids/pets.
    if((profile.audience==='kids'||profile.audience==='pet') && profile.vibe==='glam'){
      ideas=profile.audience==='kids'
        ? ['witch costume','superhero costume','fairy costume']
        : ['funny pet costume','animal pet costume','classic pet costume'];
    }
    if(profile.audience==='couples'){
      if(profile.vibe==='scary') ideas=['vampire couple costume','zombie couple costume','skeleton couple costume'];
      else if(profile.vibe==='funny') ideas=['funny couples costume','food couples costume','matching couples costume'];
      else ideas=['couples costume','matching costume','movie couples costume'];
    }
    return ideas.map(function(idea){
      var q=buildQuery(profile,idea);
      return {label:idea.replace(/\b\w/g,function(c){return c.toUpperCase()}),query:q,url:searchUrl(q)};
    });
  }

  function saveProfile(p){
    window.DHCJackProfile=p;
    try{sessionStorage.setItem(PROFILE_KEY,JSON.stringify(p))}catch(e){}
  }

  function loadProfile(){
    try{return JSON.parse(sessionStorage.getItem(PROFILE_KEY)||'null')}catch(e){return null}
  }

  function init(root){
    if(!root||root.dataset.jackConciergeReady==='1')return;
    root.dataset.jackConciergeReady='1';

    var panel=root.querySelector('[data-support-panel]');
    var finder=root.querySelector('[data-jack-finder]');
    var results=root.querySelector('[data-jack-finder-results]');
    var restart=root.querySelector('[data-jack-finder-restart]');
    var form=root.querySelector('[data-support-form]');
    var input=form&&form.elements&&form.elements.message;
    var msgs=root.querySelector('[data-support-messages]');
    var profile=loadProfile()||{};

    function openPanel(){
      if(panel){
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden','false');
      }
    }

    function showStep(name){
      if(!finder)return;
      finder.hidden=false;
      finder.querySelectorAll('[data-jack-step]').forEach(function(step){
        step.hidden=step.dataset.jackStep!==name;
      });
      if(results) results.hidden=true;
      if(restart) restart.hidden=true;
    }

    function startFinder(){
      openPanel();
      profile={};
      saveProfile(profile);
      showStep('audience');
    }

    function renderResults(){
      if(!results)return;
      var recs=recommendations(profile);
      results.innerHTML='';
      results.hidden=false;
      finder.querySelectorAll('[data-jack-step]').forEach(function(step){step.hidden=true});

      var intro=document.createElement('div');
      intro.className='dhc-jack-finder__result-intro';
      intro.innerHTML='<strong>Here are 3 directions I’d start with:</strong><span>'+budgetCopy(profile.budget)+' • '+effortTerm(profile.effort)+'</span>';
      results.appendChild(intro);

      recs.forEach(function(r,i){
        var a=document.createElement('a');
        a.className='dhc-jack-finder__result-link';
        a.href=r.url;
        a.innerHTML='<span>'+(i+1)+'</span><strong>'+r.label+'</strong><small>SEE MATCHING ITEMS →</small>';
        results.appendChild(a);
      });

      var ask=document.createElement('button');
      ask.type='button';
      ask.className='dhc-jack-finder__ask';
      ask.textContent='ASK GUS TO NARROW IT DOWN MORE';
      ask.addEventListener('click',function(){
        if(!input||!form)return;
        var prompt='Help me narrow these costume ideas down further. My preferences are: '+JSON.stringify(profile);
        form.dataset.dhcJackSilentPrompt='1';
        input.value=prompt;
        try{
          form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
        }finally{
          setTimeout(function(){
            if(input.value===prompt)input.value='';
            if(form.dataset.dhcJackSilentPrompt==='1'){
              try{delete form.dataset.dhcJackSilentPrompt}catch(_){form.dataset.dhcJackSilentPrompt=''}
            }
          },0);
        }
      });
      results.appendChild(ask);
      if(restart) restart.hidden=false;
      saveProfile(profile);
    }

    root.querySelectorAll('[data-jack-finder-start]').forEach(function(b){b.addEventListener('click',startFinder)});
    root.querySelectorAll('[data-jack-choice]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var key=btn.dataset.jackChoice;
        profile[key]=btn.dataset.value;
        saveProfile(profile);
        if(key==='audience') showStep('vibe');
        else if(key==='vibe') showStep('budget');
        else if(key==='budget') showStep('effort');
        else if(key==='effort') renderResults();
      });
    });
    if(restart) restart.addEventListener('click',startFinder);

    // Proactive, once-per-session costume-help nudge.
    var nudge=root.querySelector('[data-jack-nudge]');
    if(nudge){
      var seen=false;
      try{seen=sessionStorage.getItem('dhc_jack_nudge_seen')==='1'}catch(e){}
      if(!seen){
        var delay=Number(nudge.dataset.delay||15000);
        window.setTimeout(function(){
          if(!panel||!panel.classList.contains('is-open')){
            nudge.hidden=false;
            try{sessionStorage.setItem('dhc_jack_nudge_seen','1')}catch(e){}
          }
        },delay);
      }
      var close=nudge.querySelector('[data-jack-nudge-close]');
      var start=nudge.querySelector('[data-jack-nudge-start]');
      if(close) close.addEventListener('click',function(){nudge.hidden=true});
      if(start) start.addEventListener('click',function(){nudge.hidden=true;startFinder()});
    }
  }

  function boot(){
    document.querySelectorAll('[data-dhc-support]').forEach(init);
  }
  document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();


/* v697 Track Order page */
document.addEventListener('submit',function(e){
  var form=e.target.closest('[data-dhc-track-order-form]');
  if(!form) return;
  var order=form.querySelector('[name="order"]');
  var email=form.querySelector('[name="email"]');
  if(!order || !email || !order.value.trim() || !email.value.trim()) return;
  /* If merchant has pointed the form to a tracking app/page, normal GET submission continues. */
});


/* v714 dynamic merchandising controller */
(function(){
  function hashSeed(str){
    var h=2166136261;
    for(var i=0;i<str.length;i++){
      h ^= str.charCodeAt(i);
      h += (h<<1)+(h<<4)+(h<<7)+(h<<8)+(h<<24);
    }
    return Math.abs(h);
  }
  function seededShuffle(items, seed){
    function rand(){
      seed=(seed*9301+49297)%233280;
      return seed/233280;
    }
    for(var i=items.length-1;i>0;i--){
      var j=Math.floor(rand()*(i+1));
      var tmp=items[i];items[i]=items[j];items[j]=tmp;
    }
    return items;
  }
  function timeSeed(freq){
    var d=new Date();
    if(freq==='hourly') return d.getFullYear()+''+(d.getMonth()+1)+''+d.getDate()+''+d.getHours();
    if(freq==='weekly'){
      var onejan=new Date(d.getFullYear(),0,1);
      var week=Math.ceil((((d-onejan)/86400000)+onejan.getDay()+1)/7);
      return d.getFullYear()+''+week;
    }
    return d.getFullYear()+''+(d.getMonth()+1)+''+d.getDate();
  }
  function apply(grid){
    var items=Array.prototype.slice.call(grid.children);
    var mode=grid.dataset.mode||'collection';
    var limit=parseInt(grid.dataset.limit||'4',10);
    var freq=grid.dataset.frequency||'daily';

    if(mode==='random_refresh'){
      items.sort(function(){return Math.random()-.5;});
    } else if(mode==='rotate_time'){
      items=seededShuffle(items,hashSeed(timeSeed(freq)));
    }
    items.forEach(function(el,idx){
      el.style.display=idx<limit?'':'none';
      grid.appendChild(el);
    });
  }
  function boot(root){
    (root||document).querySelectorAll('[data-dhc-trending-grid]').forEach(apply);
  }
  document.addEventListener('DOMContentLoaded',function(){boot(document);});
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();


/* v715 product variant + cart controller */
(function(){
  function initPDP(form){
    if(!form || form.dataset.dhcPdpReady==='1') return;
    form.dataset.dhcPdpReady='1';

    var select=form.querySelector('[data-dhc-variant-select]');
    var optionInputs=Array.prototype.slice.call(form.querySelectorAll('[data-dhc-option]'));
    var addBtn=form.querySelector('[data-dhc-pdp-add]');
    var status=form.querySelector('[data-dhc-pdp-status]');
    var viewCart=form.querySelector('[data-dhc-pdp-view-cart]');

    function setStatus(text,isError){
      if(!status) return;
      status.textContent=text||'';
      status.classList.toggle('is-error',!!isError);
      status.classList.toggle('is-success',!!text && !isError);
    }

    function selectedOptions(){
      var groups={};
      optionInputs.forEach(function(input){
        if(input.checked){
          var name=input.getAttribute('name')||'';
          groups[name]=input.value;
        }
      });
      return Object.keys(groups).sort().map(function(k){return groups[k]});
    }

    function inventoryNode(){
      if(select){
        if(select.selectedIndex<0) return null;
        return select.options[select.selectedIndex]||null;
      }
      return form.querySelector('input[name="id"]');
    }

    function variantCanSell(requestedQuantity){
      var node=inventoryNode();
      if(!node) return false;
      if(node.disabled) return false;
      if(String(node.dataset.available||node.dataset.dhcStrictAvailable||'true')==='false') return false;
      if(String(node.dataset.inventoryManaged||'false')==='true'){
        var remaining=Number(node.dataset.inventoryQuantity||0);
        var requested=Math.max(1,Number(requestedQuantity)||1);
        if(remaining<=0 || remaining<requested) return false;
      }
      return true;
    }

    function syncAddState(){
      var canSell=variantCanSell(1);
      if(addBtn) addBtn.disabled=!canSell;
      return canSell;
    }

    function syncVariantFromPills(){
      if(!select || !optionInputs.length) return;
      var wanted=selectedOptions();
      if(!wanted.length) return;

      var match=Array.prototype.slice.call(select.options).find(function(opt){
        try{
          var opts=JSON.parse(opt.dataset.options||'[]');
          return opts.length===wanted.length && opts.every(function(v,i){return String(v)===String(wanted[i])});
        }catch(e){ return false; }
      });

      if(match && !match.disabled && String(match.dataset.available||'true')!=='false'){
        select.value=match.value;
        syncAddState();
        select.dispatchEvent(new Event('change',{bubbles:true}));
      }else{
        select.selectedIndex=-1;
        if(addBtn) addBtn.disabled=true;
        setStatus('That option combination is unavailable. Please choose another option.',true);
      }
    }

    optionInputs.forEach(function(input){
      input.addEventListener('change',syncVariantFromPills);
    });

    if(select){
      select.addEventListener('change',function(){
        var canSell=syncAddState();
        if(canSell) setStatus('',false);
        else setStatus('That option is sold out. Please choose another option.',true);
      });
    }

    form.addEventListener('submit',function(e){
      e.preventDefault();

      var idInput=select || form.querySelector('input[name="id"]');
      var qtyInput=form.querySelector('input[name="quantity"]');
      var variantId=idInput ? Number(idInput.value) : 0;
      var quantity=qtyInput ? Math.max(1,Number(qtyInput.value)||1) : 1;

      if(!variantId || !variantCanSell(quantity)){
        setStatus('That option is sold out or there is not enough stock for that quantity. Please choose another option.',true);
        syncAddState();
        return;
      }

      var root=(window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      var original=addBtn ? addBtn.textContent : '';

      if(addBtn){
        addBtn.disabled=true;
        addBtn.textContent='ADDING…';
      }
      setStatus('',false);
      if(viewCart) viewCart.hidden=true;

      fetch(root+'cart/add.js',{
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json'
        },
        body:JSON.stringify({
          items:[{
            id:variantId,
            quantity:quantity
          }]
        })
      })
      .then(function(r){
        if(!r.ok){
          return r.json()
            .catch(function(){return {};})
            .then(function(data){
              throw new Error(data.description || data.message || 'Unable to add this item.');
            });
        }
        return r.json();
      })
      .then(function(){
        var node=inventoryNode();
        if(node && String(node.dataset.inventoryManaged||'false')==='true'){
          var remaining=Math.max(0,Number(node.dataset.inventoryQuantity||0)-quantity);
          node.dataset.inventoryQuantity=String(remaining);
          if(remaining<=0){
            node.dataset.available='false';
            node.dataset.dhcStrictAvailable='false';
            node.disabled=true;
          }
        }
        var canStillSell=variantCanSell(1);
        setStatus(canStillSell?'Added to cart ✓':'Added to cart ✓ — this option is now sold out.',false);
        if(viewCart){
          viewCart.href=root+'cart';
          viewCart.hidden=false;
        }
        if(addBtn){
          addBtn.disabled=!canStillSell;
          addBtn.textContent='ADDED ✓';
          window.setTimeout(function(){
            addBtn.textContent=canStillSell?(original || 'ADD TO CART'):'SOLD OUT';
          },1600);
        }
        document.dispatchEvent(new CustomEvent('dhc:cart:updated'));
      })
      .catch(function(err){
        if(addBtn){
          syncAddState();
          addBtn.textContent=original || 'ADD TO CART';
        }
        setStatus(err.message || 'Unable to add this item. Please try again.',true);
      });
    });
  }

  function boot(root){
    (root||document).querySelectorAll('[data-dhc-product-form]').forEach(initPDP);
  }

  document.addEventListener('DOMContentLoaded',function(){boot(document)});
  document.addEventListener('shopify:section:load',function(e){boot(e.target)});
})();


/* v727 Jack live-backend health helper */
(function(){
  async function checkJack(root){
    if(!root || root.dataset.jackEnabled==='false') return;
    var endpoint=root.dataset.jackEndpoint||'/apps/dhc-support';
    try{
      if(window.DHCJackBackend){
        var v2=await window.DHCJackBackend.health();
        if(v2&&v2.ok){root.dataset.jackBackend='online';return;}
      }
      var controller=new AbortController();
      var timer=setTimeout(function(){controller.abort()},5000);
      var res=await fetch(endpoint+'?health=1',{method:'GET',headers:{'Accept':'application/json'},signal:controller.signal});
      clearTimeout(timer);
      root.dataset.jackBackend=res.ok?'online':'offline';
    }catch(e){
      root.dataset.jackBackend='offline';
    }
  }
  function boot(scope){
    (scope||document).querySelectorAll('[data-dhc-support]').forEach(checkJack);
  }
  document.addEventListener('DOMContentLoaded',function(){boot(document)});
  document.addEventListener('shopify:section:load',function(e){boot(e.target)});
})();


/* v728 Ask Jack bulletproof open/close controller */
(function(){
  function getWidget(){ return document.querySelector('[data-dhc-support]'); }
  function getPanel(){
    var w=getWidget();
    return w ? w.querySelector('[data-support-panel]') : null;
  }

  window.DHCOpenJack=function(e){
    try{ if(window.DHCCloseCartDrawer) window.DHCCloseCartDrawer(); }catch(_e){}
    if(e){
      if(e.preventDefault) e.preventDefault();
      if(e.stopPropagation) e.stopPropagation();
    }
    var w=getWidget(), p=getPanel();
    if(!w || !p){
      console.warn('DHC Jack: widget or panel not found');
      return false;
    }

    p.classList.add('is-open');
    p.setAttribute('aria-hidden','false');
    p.style.display='grid';
    p.style.visibility='visible';
    p.style.opacity='1';
    p.style.pointerEvents='auto';
    p.style.zIndex='2147483000';

    w.classList.add('jack-active');
    w.style.visibility='visible';
    w.style.opacity='1';
    w.style.pointerEvents='auto';

    var input=w.querySelector('[data-support-form] input,[data-support-form] textarea');
    if(input) setTimeout(function(){ try{input.focus()}catch(_){} },50);
    return false;
  };

  window.DHCCloseJack=function(e){
    if(e && e.preventDefault) e.preventDefault();
    var w=getWidget(), p=getPanel();
    if(!w || !p) return false;

    p.classList.remove('is-open');
    p.setAttribute('aria-hidden','true');
    p.style.display='none';
    p.style.visibility='hidden';
    p.style.opacity='0';
    p.style.pointerEvents='none';
    w.classList.remove('jack-active');
    return false;
  };

  document.addEventListener('click',function(e){
    var opener=e.target.closest && e.target.closest('[data-dhc-jack-open],[data-support-header-open],[data-support-open]');
    if(opener){ window.DHCOpenJack(e); return; }

    var closer=e.target.closest && e.target.closest('[data-dhc-jack-close],[data-support-close]');
    if(closer){ window.DHCCloseJack(e); }
  },true);

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape') window.DHCCloseJack(e);
  });

  document.addEventListener('DOMContentLoaded',function(){
    var p=getPanel();
    if(p && !p.classList.contains('is-open')){
      p.setAttribute('aria-hidden','true');
    }
  });
})();

/* v729 Jack mounted-state marker */
document.addEventListener('DOMContentLoaded',function(){
  var jack=document.querySelector('[data-dhc-support]');
  document.documentElement.dataset.dhcJackMounted=jack?'true':'false';
});
document.addEventListener('shopify:section:load',function(){
  var jack=document.querySelector('[data-dhc-support]');
  document.documentElement.dataset.dhcJackMounted=jack?'true':'false';
});

/* v730 Jack section-group diagnostic */
(function(){
  function mark(){
    var jack=document.querySelector('[data-dhc-support]');
    document.documentElement.setAttribute('data-dhc-jack-rendered',jack?'true':'false');
    if(jack) jack.setAttribute('data-dhc-jack-release','v730');
  }
  document.addEventListener('DOMContentLoaded',mark);
  document.addEventListener('shopify:section:load',mark);
})();

/* v731 static Jack mount diagnostic */
(function(){
  function mark(){
    var jack=document.querySelector('[data-dhc-support]');
    document.documentElement.setAttribute('data-dhc-jack-static-mounted',jack?'true':'false');
    if(jack) jack.setAttribute('data-dhc-jack-release','v731');
  }
  document.addEventListener('DOMContentLoaded',mark);
  document.addEventListener('shopify:section:load',mark);
})();

/* v734 Jack render diagnostics */
(function(){
  function mark(){
    var root=document.querySelector('[data-dhc-support]');
    var launcher=root && root.querySelector('[data-support-open]');
    document.documentElement.dataset.dhcJackRoot=root?'present':'missing';
    document.documentElement.dataset.dhcJackLauncher=launcher?'present':'missing';
  }
  document.addEventListener('DOMContentLoaded',mark);
  document.addEventListener('shopify:section:load',mark);
})();


/* v1013 mobile visual viewport hardening */
(function(){
  function syncMobileViewport(){
    var h=(window.visualViewport&&window.visualViewport.height)||window.innerHeight;
    if(!h)return;
    document.documentElement.style.setProperty('--dhc-mobile-viewport-height',Math.round(h)+'px');
  }
  syncMobileViewport();
  window.addEventListener('resize',syncMobileViewport,{passive:true});
  window.addEventListener('orientationchange',syncMobileViewport,{passive:true});
  if(window.visualViewport){
    window.visualViewport.addEventListener('resize',syncMobileViewport,{passive:true});
    window.visualViewport.addEventListener('scroll',syncMobileViewport,{passive:true});
  }
})();


/* DHC v1033 — compact mobile footer accordions */
(function(){
  function initDhcMobileFooter(){
    document.querySelectorAll('[data-dhc-footer-root] .dhc-footer__nav-col').forEach(function(col){
      if(col.dataset.dhcAccordionBound==='1') return;
      var h=col.querySelector('h3');
      if(!h) return;
      col.dataset.dhcAccordionBound='1';
      h.setAttribute('role','button');
      h.setAttribute('tabindex','0');
      h.setAttribute('aria-expanded','false');
      function toggle(){
        var open=col.classList.toggle('is-open');
        h.setAttribute('aria-expanded',open?'true':'false');
      }
      h.addEventListener('click',function(){ if(window.matchMedia('(max-width: 749px)').matches) toggle(); });
      h.addEventListener('keydown',function(e){
        if(!window.matchMedia('(max-width: 749px)').matches) return;
        if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle();}
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initDhcMobileFooter);
  else initDhcMobileFooter();
  document.addEventListener('shopify:section:load',initDhcMobileFooter);
})();

/* DHC v1052.14 — keep Jack root open-state synchronized with panel aria state. */
(function(){
  function syncJackState(root){
    if(!root) return;
    var panel=root.querySelector('[data-support-panel]');
    if(!panel) return;
    var open=panel.classList.contains('is-open') || panel.getAttribute('aria-hidden')==='false';
    root.classList.toggle('dhc-jack-is-open',open);
  }
  function bind(root){
    if(!root || root.__dhcJackStateBound) return;
    root.__dhcJackStateBound=true;
    var panel=root.querySelector('[data-support-panel]');
    if(!panel) return;
    syncJackState(root);
    try{
      new MutationObserver(function(){syncJackState(root);}).observe(panel,{attributes:true,attributeFilter:['aria-hidden','class']});
    }catch(e){}
  }
  function init(){document.querySelectorAll('[data-dhc-support]').forEach(bind);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();


/* DHC B305 visible sold-out variant labels */
(function(){
  'use strict';

  function variantNodeCanSell(opt){
    if(!opt || opt.disabled) return false;
    var available=String(opt.dataset.dhcStrictAvailable||opt.dataset.available||'true');
    if(available==='false') return false;
    if(String(opt.dataset.inventoryManaged||'false')==='true'){
      if(Number(opt.dataset.inventoryQuantity||0)<=0) return false;
    }
    return true;
  }

  function optionIndex(input){
    var match=String(input.getAttribute('name')||'').match(/^option-(\d+)$/);
    return match ? Number(match[1])-1 : -1;
  }

  function valueHasSellableVariant(select,index,value){
    if(index<0) return true;
    return Array.prototype.slice.call(select.options).some(function(opt){
      if(!variantNodeCanSell(opt)) return false;
      try{
        var values=JSON.parse(opt.dataset.options||'[]');
        return String(values[index])===String(value);
      }catch(e){
        return false;
      }
    });
  }

  function setVisibleState(input,soldOut){
    var label=input.closest('label.dhc-pdp__option-pill');
    if(!label) return;

    input.disabled=!!soldOut;
    if(soldOut) input.setAttribute('aria-disabled','true');
    else input.removeAttribute('aria-disabled');

    label.classList.toggle('is-sold-out',!!soldOut);
    label.setAttribute('data-dhc-stock-state',soldOut?'sold-out':'available');

    var badge=label.querySelector('[data-dhc-sold-out-badge]');
    if(soldOut){
      if(!badge){
        badge=document.createElement('span');
        badge.className='dhc-pdp__sold-out-badge';
        badge.setAttribute('data-dhc-sold-out-badge','');
        badge.textContent='SOLD OUT';
        var target=label.querySelector('.dhc-pdp-v1053-22__option-label')||label;
        target.appendChild(badge);
      }
      badge.hidden=false;
    }else if(badge){
      badge.remove();
    }
  }

  function syncForm(form){
    var select=form.querySelector('[data-dhc-variant-select]');
    if(!select) return;
    Array.prototype.slice.call(form.querySelectorAll('input[data-dhc-option]')).forEach(function(input){
      var label=input.closest('label.dhc-pdp__option-pill');
      if(!label) return;
      var index=optionIndex(input);
      var sellable=valueHasSellableVariant(select,index,input.value);
      setVisibleState(input,!sellable);
    });
  }

  function boot(root){
    (root||document).querySelectorAll('[data-dhc-product-form]').forEach(syncForm);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){boot(document)},{once:true});
  }else{
    boot(document);
  }

  document.addEventListener('shopify:section:load',function(e){boot(e.target)});
  document.addEventListener('dhc:cart:updated',function(){boot(document)});
})();
